"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventCategories = exports.manager = exports.setHost = exports.factory = void 0;
var wix_bi_logger_client_1 = require("@wix/wix-bi-logger-client");
var tracker = __importStar(require("./lib/tracker"));
var logger = __importStar(require("./logger"));
exports.factory = function (options) {
    if (options === void 0) { options = {}; }
    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';
    if (trackSession) {
        tracker.track(logger.factory);
    }
    return logger.factory(options);
};
exports.setHost = logger.setHost;
exports.manager = wix_bi_logger_client_1.manager;
exports.EventCategories = logger.EventCategories;
exports.default = {
    factory: exports.factory,
    setHost: logger.setHost,
    manager: wix_bi_logger_client_1.manager,
    EventCategories: logger.EventCategories,
};
//# sourceMappingURL=tracking-logger.js.map